import Axios from '../api/axios';
import * as glb from '../globals.js';
import { dispatchLookupUpdated, persistLookupCache } from './lookupStorage';

export const MESLEK_EVENT = 'meslekLkpUpdated';

let _inflight = null;

/** Session cache: login/auth zaten doldurur. force=true yalnızca MESLEK ekranı CRUD sonrası. */
export function refreshGlobalMeslekLkp({ force = false } = {}) {
    const cached = Array.isArray(glb.default.meslekLkp) ? glb.default.meslekLkp : [];
    if (!force && cached.length > 0) {
        return Promise.resolve(cached);
    }
    if (_inflight) return _inflight;
    _inflight = Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}doalls/lkp?ptype=MESLEK`)
        .then((res) => {
            glb.default.meslekLkp = res.data || [];
            persistLookupCache('meslekLkp', glb.default.meslekLkp);
            dispatchLookupUpdated(MESLEK_EVENT);
            return glb.default.meslekLkp;
        })
        .finally(() => {
            _inflight = null;
        });
    return _inflight;
}
